import booleanContains from '@turf/boolean-contains';

/**
 * Filter issues by selected region
 * @param {Array} issues
 * @param {Object} selectedRegion
 */
export function filterBySelectedRegion(issues, selectedRegion) {
  return issues.filter((i) =>
    booleanContains(selectedRegion?.geoJSON, i.geoJSON)
  );
}
